import { useContext, useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import Navbar from '../components/common/navbar/Navbar';
import Footer from "../components/common/footer/Footer";
import Home from '../pages/primary/Home';
import About from '../pages/primary/About';
import Contact from '../pages/primary/Contact';
import MarketReports from "../pages/primary/ourSolutions/MarketReports";
import CompanyProfiles from './../pages/primary/ourSolutions/CompanyProfiles';
import Articles from "../pages/primary/resources/Articles";
import PressReleases from "../pages/primary/resources/PressReleases";
import CaseStudies from "../pages/primary/resources/CaseStudies";
import NewsLetters from "../pages/primary/resources/NewsLetters";
import FAQs from "../pages/secondory/FAQs";
import PurchaseCards from "../pages/secondory/PurchaseCards";
import ComingSoon from "../pages/secondory/ComingSoon";

function AppRoutes() {

  const location = useLocation();
  const prevPath = useRef(location.pathname);
  const { setInputValue, setFilterByCategory } = useContext(ThemeContext);

  useEffect(() => {
    if (prevPath.current === "/syndicate_reports" && location.pathname !== "/syndicate_reports") {
      console.log("Leaving /syndicate_reports → Resetting context filters");
      setInputValue(null);
      setFilterByCategory(null);
    }

    prevPath.current = location.pathname;
  }, [location.pathname]);

  return (
    <>
      <Navbar />

      <Routes>
        {/* Primary Menu */}
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />

        {/* Our Solutions */}
        <Route path='/syndicate_reports' element={<MarketReports />} />
        <Route path='/competitive_intelligence' element={<CompanyProfiles />} />

        {/* Resources */}
        <Route path='/articles' element={<Articles />} />
        <Route path='/press_releases' element={<PressReleases />} />
        <Route path='/case_studies' element={<CaseStudies />} />
        <Route path='/news_letters' element={<NewsLetters />} />

        {/* Other Pages */}
        <Route path='/faq_s' element={<FAQs />} />
        <Route path='/purchase_cards' element={<PurchaseCards />} />
        <Route path='/coming_soon' element={<ComingSoon />} />
      </Routes>

      <Footer/>
    </>
  );
}

export default AppRoutes;
